const attachmentFilesEquipmentModelsModal = {
  createTitle: 'Include Attachment',
  editTitle: 'Include Attachment',
  noResults: 'no results found'
};

export default attachmentFilesEquipmentModelsModal;